
import { Modal, ModalOverlay, ModalContent, ModalBody, ModalCloseButton, Icon, Flex } from "@chakra-ui/react"
import { Center, Text, Button } from "@chakra-ui/react"
import { InfoCircle } from "../icons/icons"

const NotificationCancelEventModal = (
    { isOpen, onClose, onConfirm, onOpenRefundPolicy, isLoading } : 
    { isOpen: boolean, onClose: () => void, onConfirm: () => void, onOpenRefundPolicy:() => void, isLoading : boolean }
) => { 



    return <Modal isOpen={isOpen} onClose={onClose} size='md'>
        <ModalOverlay />

        <ModalContent>
            <ModalCloseButton />
                
            <ModalBody p='0 0 20px 0'>
                <Center>
                    <Icon w="50px" h="50px" viewBox="0 0 50 50" fill="none" color='#FFCC00'>
                        <InfoCircle />

                    </Icon>
                </Center>
                <Center>
                    <Text 
                        variant='title' fontSize='lg' fontWeight='500' mb='20px' mt='10px'
                    >Are you sure you want to cancel this event?</Text>
                    
                </Center>
                <Center>
                    <Text 
                        textAlign='center'
                        variant='subtle' fontSize='md' fontWeight='400' mb='20px'
                    >
                        By clicking the 'Confirm' button below, you understand our <Button onClick={onOpenRefundPolicy} variant='link'>refund policy</Button>.
                    </Text>
                </Center>
                <Flex mt='20px' mb='10px' gap='10px'>
                    <Button 
                        variant='light' w='100%'
                        onClick={onClose}
                    >Close</Button>
                    <Button 
                        variant='heavy' w='100%'
                        onClick={onConfirm}
                        isLoading={isLoading}
                    >Confirm</Button>
                </Flex>
                
            </ModalBody>
        </ModalContent>
    </Modal>

}

export default NotificationCancelEventModal;